import type { ReactElement } from 'react';
import React from 'react';
import { observer } from 'mobx-react-lite';
import Head from 'next/head';

import { EventWizard } from '../../components/events/EventWizard';
import LayoutWithHeader from '../../components/layout/LayoutWithHeader';
// import VendorWizard from '../../components/vendors/VendorWizard';
import strings from '../../config/strings';
import { UserRole } from '../../types/enums';
import { setPageTitle } from '../../utils/base';

const AddEvent = () => {
  return (
    <>
      <Head>
        <title>{setPageTitle(strings.labels.addEvent)}</title>
        <meta content="noindex, nofollow" name="robots" />
      </Head>
      <EventWizard />
    </>
  );
};

AddEvent.getLayout = function getLayout(page: ReactElement) {
  return (
    <LayoutWithHeader
      allowedRoles={[UserRole.User]}
      authRequired
      bannerSubTitle={strings.messages.addEvent}
      bannerTitle={strings.titles.addEvent}
    >
      {page}
    </LayoutWithHeader>
  );
};

export default observer(AddEvent);
